import { render, staticRenderFns } from "./SpacesEditorToolbar.vue?vue&type=template&id=d874d486&scoped=true"
import script from "./SpacesEditorToolbar.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorToolbar.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorToolbar.scss?vue&type=style&index=0&id=d874d486&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d874d486",
  null
  
)

export default component.exports